export const configurations = {
  operatorsByType: {},
  measures: {},
  token: '',
  hashToken: ''
}

export default {
  configurations
}
